// add Only to the countdown
function addOnlyToCountdown() {

  function addOnly() {
    const countdownDays = $('.countdownDays');
    const countdownDaysText = countdownDays.html();
    countdownDays.html(countdownDaysText.replace(/(\d+)/, 'Only $1'));
  }

  function setCountdownOpacity() {
    $('.siteInfoBanner').each((i, element) => {
      $(element).css('opacity', 1);
    });
  }

  const body = $('body');

  if (
    body.hasClass('siteInfoBannerWidgetDateIsPast') ||
    body.hasClass('siteInfoBannerWidgetEventHappening')
  ) {
    setCountdownOpacity()
  } else {
    setTimeout(() => {
      addOnly();
      setCountdownOpacity();
    }, 2000);
  }
}

// Move Countdown to Swiper Widget on Mobile

function prependBannerToSwiperContainers(siteInfoBanner) {
  $('.swiper-content-container .container').each((i, element) => {
    $(siteInfoBanner).clone().prependTo(element);
  });
}

let headerModified = false;
function changeHeaderLayout() {
 const siteInfoBanner = document.querySelector('.siteInfoBanner');
  const headerLogo = $('.header-logo');

  if (!headerModified && window.innerWidth <= 815) {
    setTimeout(() => {
      prependBannerToSwiperContainers(siteInfoBanner);
      $('.homepage .header').find('.siteInfoBanner').remove();
      headerLogo.appendTo('.headerInnerContent .links .links-top');
    }, 200);
    headerModified = true;
  } else if (headerModified && window.innerWidth >= 815) {
    $(siteInfoBanner).appendTo('.headerInnerContent .header-top');
    headerLogo.appendTo('.headerInnerContent .header-top');
    $('.swiper-content-container .container .siteInfoBanner').remove();
    headerModified = false;
  }
}

// modify button nav toggle
function modifyBtnNavToggle() {
  const navToggle = document.querySelector('.mobile-nav-toggle');

  navToggle.innerHTML = `
    <span></span>
    <span></span>
    <span></span>
  `;
  navToggle.setAttribute('tabindex', '0');
  navToggle.setAttribute('role', 'button');
  navToggle.setAttribute('aria-label', 'open menu');
}

// modify buy tickets button
function modifyBuyTicketsBtn() {
  $('header .ticket')
    .addClass('button')
    .text('buy tix')
    .attr({ 'aria-label': 'press here to buy tickets', role: 'button' }).html(`
    <svg version="1.1" id="ticket-bg" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px"
      y="0px" viewBox="0 0 188.9 74.32" style="enable-background:new 0 0 188.9 74.32;" xml:space="preserve">
      <path class="st1" d="M176.87,61.86c0-1.97,4-3.58,8.94-3.58v-9c-4.94,0-8.94-1.6-8.94-3.58c0-1.97,4-3.58,8.94-3.58v-9
    c-4.94,0-8.94-1.6-8.94-3.58c0-1.97,4-3.58,8.94-3.58v-9c-4.94,0-8.94-1.6-8.94-3.58s4-3.58,8.94-3.58V2.68H2.26v7.16
    c4.66,0.12,8.34,1.67,8.34,3.56s-3.69,3.44-8.34,3.56v9.02c4.66,0.12,8.34,1.67,8.34,3.56c0,1.89-3.69,3.44-8.34,3.56v9.02
    c4.66,0.12,8.34,1.67,8.34,3.56c0,1.89-3.69,3.44-8.34,3.56v9.02c4.66,0.12,8.34,1.67,8.34,3.56s-3.69,3.44-8.34,3.56v6.38h183.55
    v-6.37C180.87,65.43,176.87,63.83,176.87,61.86z" />
    </svg>
    <span>Buy Tix</span>
    <svg version="1.1" id="ticket-arrow" xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 38.32 48"
    style="enable-background:new 0 0 38.32 48;" xml:space="preserve">
    <path class="st0" d="M6.42,1.51C7.15,1.65,8.22,2.54,9,3.12c8.27,6.15,16.56,12.28,24.79,18.49c3.6,2.72,3.54,4.77-0.19,7.28
                    c-8.41,5.66-16.89,11.22-25.3,16.88c-1.76,1.18-3.08,1.03-4.12-0.82c-0.65-1.16-1.22-2.36-1.81-3.55c-1.75-3.55-1.76-3.59,1.38-6.14
                    c3.35-2.73,6.66-5.52,10.13-8.1c1.97-1.47,2.1-2.57,0.27-4.27c-3.53-3.28-6.9-6.74-10.34-10.11C0.89,9.9,0.88,9.9,2.78,6.05
                    c0.59-1.19,1.18-2.38,1.93-3.46C5.04,2.11,5.69,1.37,6.42,1.51z" />
    </svg>`);
}
// modify featureLineup layout
function modifyFeatureLineup() {
  $('.featureLineupContainer').each((i, element) => {
    const title = $(element).find('.featureLineup-title');
    const titleText = title.text().trim();
    if (titleText.length > 45) {
      title.text(`${titleText.substring(0, 45)}...`);
      // add a tooltip to the title with the full text
      title.attr('title', titleText);
    } else {
      title.text(titleText);
    }

    $(element)
      .find('.featureLineup-buynow a.button, .featureLineup-more .button')
      .addClass('buyNowButton');
    // $(element).find('.featureLineup-headline').remove();
    // get the text of .featureLineup-title and wrap it in a span

    const description = $(element).find('.featureLineup-text').eq(1);
    const descriptionText = description.text();
    const moreButton = $(element).find('.featureLineup-more');
    description.empty();
    description
      .html(`<div class="featureLineup-description">${descriptionText}</div>`)
      .append(moreButton);
  });
}

// modify footer Copyright
function modifyFooterCopyright() {
  const firstSpan = $('.site-copyright span:first-of-type').text().split(',');
  const rights = $('.site-copyright span:last-of-type').text();
  const copy = firstSpan[0];
  const org = firstSpan[1];
  $('.site-copyright').html(`
    <span>${rights}</span>
    <span class="footer-navigation__separator">|</span>
    <span>${org}</span>
    <span class="footer-navigation__separator">|</span>
    <span>${copy}</span>
  `);
}

function modifySponsors() {
  const sponsorWidgetContainer = $('#sponsorWidgetContainer');
  const arrows = sponsorWidgetContainer.find('.sponsorArrow');
  arrows.each((i, arrow) => {
    $(arrow).find('span')
      .append(`<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 28 52" xml:space="preserve">
<path class="st0" d="M1.6,22.5C8.3,15.2,14.4,9.4,21.4,1.7C22,0.9,23.3,0,24,1.6s1.7,4.1,2,5c0.5,1.3,0.7,2.3-0.3,3.6
	c-3.4,4-12.1,13.3-12.1,13.3c-0.4,0.5-0.4,1.2-0.1,1.7c3.1,5.2,11.7,16.1,11.9,16.4c1.4,1.9,1.4,2.7,1,4.4c-0.2,1-0.6,2.3-1.3,4.1
	c-0.7,2-2.1,2.3-3.6,0.8c-1.6-1.6-3-3.5-4.4-5.3c-4.9-6-9.8-12.1-14.7-18.1c-0.4-0.5-0.8-1-1.2-1.6C0.6,24.8,0.8,23.4,1.6,22.5z"/>
</svg>`);
  });
}

$(document).ready(() => {
  // Prepend General Message Banner to Header
  $('.generalmessage').prependTo('header');

  modifyBtnNavToggle();
  modifyBuyTicketsBtn();
  modifyFeatureLineup();
  modifyFooterCopyright();
  if (window.location.pathname === '/') {
    $(window).load(() => {
      setTimeout(() => {
        addOnlyToCountdown();
      }, 1000);
      setTimeout(() => {
        modifySponsors();
      }, 2000);
    });
  }

  $(window).load(() => {
    setTimeout(() => {
      changeHeaderLayout();
    }, 200);
    setTimeout(addOnlyToCountdown, 1000);
  });
  $(window).resize(() => {
    changeHeaderLayout();
  });
});
